import React, { useState, useEffect } from 'react';
import { Search, Empty, Skeleton, Tag, Toast, List, PullRefresh } from 'react-vant';
import { getRegistrations, getSessions } from '../../../api/club';
import dayjs from 'dayjs';

const RegistrationList = ({ isAdmin, academicYear }) => {
  const [sessions, setSessions] = useState([]);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  // 获取所有批次，用于显示社团名称
  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const res = await getSessions({ page: 1, page_size: 100 });
        setSessions(res.items || []);
      } catch (e) {
        console.error('获取批次失败:', e);
      }
    };
    fetchSessions();
  }, []);

  const fetchData = async (isRefresh = false) => {
    if (loading) return;
    setLoading(true);
    try {
      const currentPage = isRefresh ? 1 : page;
      const res = await getRegistrations({
        page: currentPage,
        page_size: 20,
        search: searchText || undefined,
        academic_year: (academicYear && academicYear !== 'all') ? academicYear : undefined
      });
      
      const newItems = res.items || [];
      if (isRefresh) {
        setList(newItems);
        setPage(2);
      } else {
        setList([...list, ...newItems]);
        setPage(currentPage + 1);
      }
      setHasMore(newItems.length === 20);
    } catch (error) {
      Toast.fail('获取名单失败');
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    fetchData(true);
  }, [searchText, academicYear]);

  const onRefresh = () => {
    setRefreshing(true);
    fetchData(true);
  };

  const renderStatus = (status) => {
    switch (status) {
      case 'confirmed': return <Tag type="success" plain>已确认</Tag>;
      case 'waitlisted': return <Tag type="warning" plain>候补中</Tag>;
      case 'cancelled': return <Tag type="default" plain>已取消</Tag>;
      default: return <Tag plain>{status}</Tag>;
    }
  };

  return (
    <div style={{ background: '#f8fafc', minHeight: '80vh' }}>
      <div style={{ position: 'sticky', top: '90px', zIndex: 10, background: '#f8fafc', padding: '12px' }}>
        <Search
          value={searchText}
          onChange={setSearchText}
          placeholder="搜索学生姓名"
          style={{ padding: 0, background: 'transparent' }}
          clearable
        />
      </div>

      <PullRefresh onRefresh={onRefresh}>
        {list.length === 0 && !loading ? (
          <Empty description="暂无报名信息" />
        ) : (
          <div style={{ padding: '0 12px 12px' }}>
            <List
              finished={!hasMore}
              onLoad={() => fetchData()}
              loading={loading}
              finishedText="没有更多了"
            >
              {list.map(reg => (
                <div key={reg.id} style={{
                  background: '#fff',
                  borderRadius: '12px',
                  padding: '16px',
                  marginBottom: '12px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <span style={{ fontSize: '16px', fontWeight: 800, color: '#0f172a' }}>{reg.student_name}</span>
                    {renderStatus(reg.status)}
                  </div>
                  <div style={{ fontSize: '13px', color: '#475569', marginBottom: '4px' }}>
                    <strong>社团：</strong>{reg.club_name}
                  </div>
                  <div style={{ fontSize: '12px', color: '#94a3b8', display: 'flex', justifyContent: 'space-between' }}>
                    <span>{reg.class_name || '未知班级'}</span>
                    <span>{dayjs(reg.registered_at).format('MM-DD HH:mm')}</span>
                  </div>
                </div>
              ))}
            </List>
          </div>
        )}
      </PullRefresh>
    </div>
  );
};

export default RegistrationList;
